import { render } from "./SurfaceProduits.vue?vue&type=template&id=76273ff2&scoped=true"
import script from "./SurfaceProduits.vue?vue&type=script&lang=js"
export * from "./SurfaceProduits.vue?vue&type=script&lang=js"

import "./SurfaceProduits.vue?vue&type=style&index=0&id=76273ff2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76273ff2"]])

export default __exports__